import React from 'react';
import { TrendingUp, Award, Clock, Building2 } from 'lucide-react';

const CaseStudyStats = ({ stats }) => {
  const statIcons = {
    projects: Building2,
    satisfaction: Award,
    improvement: TrendingUp,
    support: Clock
  };

  return (
    <section className="py-24 bg-gradient-to-br from-primary/5 via-background to-primary/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
            {stats.title}
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            {stats.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.metrics.map((metric, index) => {
            const IconComponent = statIcons[metric.label.toLowerCase().replace(/\s+/g, '')] || TrendingUp;
            
            return (
              <div key={index} className="text-center group">
                <div className="relative">
                  {/* Background decoration */}
                  <div className="absolute inset-0 bg-primary/10 rounded-full blur-xl group-hover:bg-primary/20 transition-colors"></div>
                  
                  {/* Icon */}
                  <div className="relative flex justify-center mb-6">
                    <div className="p-4 rounded-full bg-primary/10 group-hover:bg-primary/20 transition-colors">
                      <IconComponent className="h-8 w-8 text-primary" />
                    </div>
                  </div>
                  
                  {/* Number */}
                  <div className="relative text-4xl md:text-5xl font-bold text-primary mb-2">
                    {metric.number}
                  </div>
                  
                  {/* Label */}
                  <div className="relative text-lg font-semibold text-foreground mb-2">
                    {metric.label}
                  </div>
                  
                  {/* Description */}
                  <div className="relative text-sm text-muted-foreground">
                    {metric.description}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Additional trust indicators */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20">
            <Award className="h-4 w-4 text-primary" />
            <span className="text-sm font-medium text-primary">Trusted by 50+ companies across 6 industries</span>
          </div>
        </div>

        {/* Industry breakdown */}
        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {[
            { name: 'Telecommunications', count: '12' },
            { name: 'Banking & Finance', count: '8' },
            { name: 'Retail & E-commerce', count: '10' },
            { name: 'Aviation', count: '5' },
            { name: 'Transportation', count: '7' },
            { name: 'Postal Services', count: '8' }
          ].map((industry, index) => (
            <div key={index} className="text-center p-4 rounded-lg bg-muted/30 border border-border/50">
              <div className="text-2xl font-bold text-primary mb-1">{industry.count}</div>
              <div className="text-xs text-muted-foreground">{industry.name}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudyStats;
